<template>
  <div class="pageLoading">
    <div class="inner-loading" />
  </div>
</template>
<script>
export default {
  name: 'PageLoadingV2'
}
</script>

<style lang='scss' scoped>
.pageLoading {
	max-width: 1260px;
	margin: 0 auto;
	box-sizing: border-box;
	.inner-loading {
		height: 600px;
		width: 100%;
		animation: 1s linear 0s infinite normal none running a, 1s linear 0s infinite normal none running b;
    	background: linear-gradient(to right, rgb(238, 238, 238) 2%, rgb(221, 221, 221) 18%, rgb(238, 238, 238) 33%) 0% 0% / 200%;
    	border-radius: 8px;
	}
	@keyframes a {
		0% {
			background-position: -100% 0px;
		}
		100% {
			background-position: 100% 0px;
		}
	}
	@keyframes b {
		0% {
			opacity: 1;
		}
		50% {
			opacity: 0.8;
		}
		100% {
			opacity: 1;
		}
	}
}

</style>
